<div class="flex items-center pb-6">
  @if (showSearch()) {
    <div class="quick-search md-full h-[42px] items-center rounded-lg md:w-80">
      <input
        (ngModelChange)="onInputChange($event)"
        [(ngModel)]="searchText"
        [placeholder]="configuration?.searchPlaceholder ?? 'global.quickSearch' | translate"
        aria-label="Quick Search Input"
        id="filter-text-box"
        matInput />

      <button aria-label="Quick Search Button" mat-icon-button matSuffix>
        @if (searchText.length > 0) {
          <mat-icon class="mr-2" (click)="onClearSearch()">close</mat-icon>
        } @else {
          <mat-icon class="mr-2">search</mat-icon>
        }
      </button>
    </div>
  }

  <div class="gap ml-auto flex items-center gap-4">
    <ng-content></ng-content>
    @if (configuration?.buttons) {
      <ng-container>
        @for (button of configuration?.buttons; track button.text) {
          <app-button
            (click)="button.action()"
            [attr.aria-label]="'Header Button ' + button.text"
            [icon]="button.icon"
            [color]="button.color ?? ButtonColor.PRIMARY"
            [style]="button.style">
            {{ button.text | translate }}
          </app-button>
        }
      </ng-container>
    }
  </div>
</div>
